import { AxiosInstance } from "axios";
import { NotificationData } from "./notification.type";

export default class Notification {
  private axios: AxiosInstance;

  constructor(axios: AxiosInstance) {
    this.axios = axios;
  }

  public async getPublishedNotifications(signal?: AbortSignal) {
    const url: string = `/notifications/published`
    return this.axios.get(url, {signal})
  }


}
